import { Alert, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import type { TargetingFormData } from '../CampaignTargetingStep';
import { formatRecipients } from './toasts';

interface TargetingSummaryAlertProps {
  data: TargetingFormData;
  onModify: () => void;
}

function TargetingSummaryAlert({ data, onModify }: TargetingSummaryAlertProps) {
  const label = data.cashdeskTarget !== null ? 'Ciblage spécifique Caisse — ' : data.listId !== null ? 'Liste — ' : 'Requête ';

  return (
    <Alert
      icon={<CheckCircleIcon fontSize="small" />}
      severity="success"
      sx={{ mb: 2, fontSize: '0.8rem' }}
      action={<Button size="small" color="inherit" onClick={onModify}>Modifier</Button>}
    >
      {label}<strong>{data.queryDescription}</strong>
      {data.nbRecipients !== null && <span> — {formatRecipients(data.nbRecipients)}</span>}
    </Alert>
  );
}

export default TargetingSummaryAlert;
